/******************************************************************************************
 *	Reseller Invitations
 *******************************************************************************************/
(function() {
  

  angular.module('rcServices.resellerInvitation', []).service(
    'ResellerInvitation',
    /* @ngInject */
    function(jilResellerInvitations) {
      //Update invitation email
      this.updateEmail = function(resellerId, payload) {
        return jilResellerInvitations.resellerInvitations.update(
          {
            resellerId
          },
          payload
        ).$promise;
      };
    }
  );
})();
